import { GeneratedJobType, Message } from 'components/JobGenerator/types';

export const ALL = 'all';
export const BOOKMARK = 'bookmark';
export const SEARCH = 'search';
export const RONE = 'r-one';

export const FILTER_LAST_3_MONTHS = 'last_3_months';
export const FILTER_LAST_6_MONTHS = 'last_6_months';

export type Anchor = 'top' | 'left' | 'bottom' | 'right';
export type TabsType = 'all' | 'bookmark' | 'search' | 'r-one';
export interface TemporaryDrawerType {
    created_at: string;
    value: string;
    document_id: string;
}

export interface ContextWithAnswersType extends TemporaryDrawerType {
    versions: VersionType[];
}

export interface ItemType {
    month: string;
    year: number;
    day: number;
    title: string;
    subtitle: string;
    document_id: string;
    messages: Message[];
    isSaved?: boolean | null;
    jobOrderId?: string;
}

export interface FormattedObjectType {
    id: string;
    year: number;
    items: ItemType[];
}

export interface ContextObjType {
    [key: string]: FormattedObjectType;
}

export interface VersionType {
    answer: string;
    created_at: string;
    question_id: string;
    version: string;
    document_id: string;
    isHidden: boolean;
}

export interface VersionWithContextIdType {
    [key: string]: VersionType[];
}

export interface JobsTypes extends GeneratedJobType {
    document_id: string;
}

export type Inputs = {
    searchValue: string;
    isBookmarkSelected: boolean;
    monthFilter: string;
};
